import { Country } from '../interfaces/Country';
import { Select } from 'antd';
import useCountries from '../customhooks/useCountries';

interface CountryAutocompleteProps {
    onHandleChange: (value: Country) => void;
    initialValue?: string;
    error?: boolean;
    errorMessage?: string;
    label?: string;
}

const CountriesDropdown = ({
    initialValue,
    onHandleChange,
    error,
    errorMessage,
    label
}: CountryAutocompleteProps) => {
    const { countries, isCountriesLoading } = useCountries();

    return (
        <div>
            <label
                htmlFor='input-group-1'
                className='block mb-2 text-sm font-medium text-gray700 text-left'
            >
                {label ?? 'Select Country'}
            </label>
            <Select
                style={{ borderRadius: '8px' }}
                className='w-full h-[45px] rounded-[8px]'
                id='corporateIndustryId'
                loading={isCountriesLoading}
                status={error ? 'error' : undefined}
                value={initialValue}
                showSearch
                onChange={(value) => {
                    const country = countries.find(
                        (country) => country.id === Number(value)
                    );
                    onHandleChange(country as Country);
                }}
            >
                {countries?.map((ind) => (
                    <Select.Option key={`country-${ind.id}`} value={ind.id}>
                        <div className='flex items-center'>
                            <img
                                src={ind?.flagImageUrl}
                                alt={`${ind.name}-flag`}
                                className='w-4 h-4'
                            />
                            <span className='ml-2'>{ind.name}</span>
                        </div>
                    </Select.Option>
                ))}
            </Select>

            <p className='text-sm text-red100'>{errorMessage}</p>
        </div>
    );
};

export default CountriesDropdown;
